import { NgModule } from '@angular/core';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTreeModule } from '@angular/material/tree';

const material = [
  MatPaginatorModule,
  MatTableModule,
  MatFormFieldModule,
  MatSidenavModule,
  MatCardModule,
  MatDialogModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatSelectModule,
  MatTabsModule,
  MatCheckboxModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatTooltipModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatToolbarModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatTreeModule
];

@NgModule({
  declarations: [],
  imports: [
    material,
  ],
  exports: [
    material
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pe-PE' }
  ]
})
export class MaterialModule { }